import { type ComponentType, type PropsWithChildren } from "react";
import { TabsPrimitive } from "ui";

import { type NavigationTab } from "./NavigationTabs";

interface NavigationTabsTriggerProps {
  tab: NavigationTab;
  Link: ComponentType<PropsWithChildren<{ to: string }>>;
}

export function NavigationTabsTrigger(props: NavigationTabsTriggerProps) {
  return (
    <TabsPrimitive.TabsTrigger
      asChild
      value={props.tab.tabId}
      disabled={props.tab.disabled}
    >
      <props.Link to={props.tab.href}>{props.tab.label}</props.Link>
    </TabsPrimitive.TabsTrigger>
  );
}
